import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import {
  WordSelectionMode,
  WordSelectionModeDetails,
} from '../../../constants/MemoryGames/wordSelectionMode';
import { CircleCheckbox } from '../../Molecules';
import { SvgIcon } from '../../Molecules';
import { ActionSheetContainer } from '../Containers/ActionSheetContainer';
import styles from './SelectWordModePopup.module.css';

type SelectWordModePopupProps = {
  selectedMode: WordSelectionMode;
  onPrimary: () => void;
  onSelectMode: (mode: WordSelectionMode) => void;
};

export const SelectWordModePopup = (props: SelectWordModePopupProps) => {
  const { selectedMode, onPrimary, onSelectMode } = props;
  const { t } = useTranslation();

  const wordSelectionModeDetails = Object.entries(WordSelectionModeDetails).map(
    ([key, value]) => {
      return {
        type: key as WordSelectionMode,
        icon: value.icon,
        displayName: value.displayName,
      };
    },
  );

  return (
    <ActionSheetContainer onPrimaryButtonClick={onPrimary}>
      <div className={styles.selectWordMode}>
        <div className={styles.titleRow}>
          <p className={styles.title}>{t('Selection Mode')}</p>
        </div>
        <hr className={styles.divider} />
        <ul className={styles.languageList}>
          {wordSelectionModeDetails.map((item, index) => (
            <Fragment key={item.type}>
              <li
                className={styles.languageItem}
                onClick={() => {
                  onSelectMode(item.type);
                }}
              >
                <SvgIcon
                  name={item.icon}
                  width={24}
                  height={24}
                  stroke="black"
                  fill="black"
                />
                <div className={styles.languageNames}>
                  {t(item.displayName)}
                </div>
                <CircleCheckbox
                  checked={selectedMode === item.type}
                  onChange={() => {
                    onSelectMode(item.type);
                  }}
                />
              </li>
              {index < wordSelectionModeDetails.length - 1 && <hr />}
            </Fragment>
          ))}
        </ul>
      </div>
    </ActionSheetContainer>
  );
};
